import React, { useState } from 'react';
import { getCity, setCity, clearCity, LocationData } from '../lib/location';
import { COLORS, SPACING } from '../styles/theme';

export function LocationSettings() {
  const [location, setLocation] = useState<LocationData | null>(getCity);
  const [input, setInput] = useState('');
  const [editing, setEditing] = useState(false);

  function handleSet() {
    const trimmed = input.trim();
    if (!trimmed) return;
    setCity(trimmed);
    setLocation(getCity());
    setInput('');
    setEditing(false);
  }

  function handleClear() {
    clearCity();
    setLocation(null);
  }

  return (
    <div style={{ padding: SPACING.lg, fontFamily: 'monospace' }}>
      <h3 style={{ color: COLORS.text, borderBottom: `1px solid ${COLORS.border}`, paddingBottom: SPACING.sm, marginBottom: SPACING.md, fontSize: '13px' }}>
        Location
      </h3>

      {location ? (
        <div>
          <div style={{ marginBottom: SPACING.sm, fontSize: '12px', color: COLORS.text }}>
            Your city: <strong>{location.city}</strong>
            {location.country && <span style={{ color: COLORS.textMuted }}>, {location.country}</span>}
            <span style={{ color: COLORS.textMuted, marginLeft: 8 }}>
              ({location.source === 'ip' ? 'auto-detected' : 'manually set'})
            </span>
          </div>
          <div style={{ display: 'flex', gap: SPACING.sm }}>
            <button
              onClick={() => setEditing(true)}
              style={{ background: 'transparent', border: `1px solid ${COLORS.accent}`, color: COLORS.accent, padding: `${SPACING.xs} ${SPACING.sm}`, cursor: 'pointer', fontSize: '12px', fontFamily: 'monospace' }}
            >
              Change city
            </button>
            <button
              onClick={handleClear}
              style={{ background: 'transparent', border: `1px solid ${COLORS.border}`, color: COLORS.textMuted, padding: `${SPACING.xs} ${SPACING.sm}`, cursor: 'pointer', fontSize: '12px', fontFamily: 'monospace' }}
            >
              Clear (opt out of local feeds)
            </button>
          </div>
        </div>
      ) : (
        <p style={{ fontSize: '12px', color: COLORS.textMuted, marginBottom: SPACING.md }}>
          No city set. Your content won't appear in local feeds and Local mode will show all content.
        </p>
      )}

      {(!location || editing) && (
        <div style={{ marginTop: SPACING.md, display: 'flex', gap: SPACING.sm }}>
          <input
            type="text"
            value={input}
            onChange={e => setInput(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter') handleSet(); }}
            placeholder="Enter city name"
            style={{ flex: 1, fontFamily: 'monospace', fontSize: '12px', background: COLORS.bg, color: COLORS.text, border: `1px solid ${COLORS.border}`, padding: SPACING.xs }}
          />
          <button
            onClick={handleSet}
            style={{ background: COLORS.accent, color: '#fff', border: 'none', padding: `${SPACING.xs} ${SPACING.sm}`, cursor: 'pointer', fontFamily: 'monospace', fontSize: '12px', fontWeight: 'bold' }}
          >
            Set
          </button>
          {editing && (
            <button
              onClick={() => { setEditing(false); setInput(''); }}
              style={{ background: 'transparent', border: `1px solid ${COLORS.border}`, color: COLORS.textMuted, padding: `${SPACING.xs} ${SPACING.sm}`, cursor: 'pointer', fontSize: '12px', fontFamily: 'monospace' }}
            >
              Cancel
            </button>
          )}
        </div>
      )}

      <p style={{ marginTop: SPACING.md, fontSize: '11px', color: COLORS.textMuted, lineHeight: 1.5 }}>
        City is auto-detected from your IP on first visit — one request, stored locally, never tracked again.
        Clearing it removes you from all local feeds. City-level only — no GPS, no coordinates.
      </p>
    </div>
  );
}
